import { Suit } from './definitions';
export class Card {
    constructor(rank, suit) {
        this.rank = rank;
        this.suit = suit;
        this.pile = '';
        this.order = 0;
        this.meldId = '';
        this.id = rank + suit + '';
        this.isSelected = false;
    }
    toString() {
        return `${this.rank}${this.suit.toString()}`;
    }
    compareTo(other) {
        if (other.id === this.id) {
            return true;
        }
        return false;
    }
    static fromObject(input) {
        const card = new Card(input.rank, input.suit);
        Object.assign(card, input);
        return card;
    }
    static fromString(input) {
        const rank = Card.getRank(input);
        const suit = Card.getSuit(input);
        return new Card(rank, suit);
    }
    static getRank(card) {
        const rank = card.substring(0, card.length - 1);
        return rank;
    }
    static getSuit(card) {
        const suit = card.charAt(card.length - 1).toUpperCase();
        switch (suit) {
            case 'H':
                return Suit.Hearts;
            case 'D':
                return Suit.Diamonds;
            case 'S':
                return Suit.Spades;
            case 'C':
                return Suit.Clubs;
        }
        throw new Error(`Invalid suit for card: '${suit}'`);
    }
}
//# sourceMappingURL=data:application/json;base64,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